import * as React from 'react';
import {EditableProps} from "../../common/props/EditableProps";
import {DisableableProps} from "../../common/props/DisableableProps";
import {FocusableProps} from "../../common/props/FocusableProps";
import {PressableProps} from "../../common/props/PresableProps";
import {HotKeys} from "react-hotkeys";
import {FormGroupProps} from "../../common/props/FormGroupProps";
import {PlaceholderProps} from "../../common/props/PlaceholderProps";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import TextArea from '../../../hiberUiKit/src/atoms/TextArea/TextArea';
import {none, option} from "ts-option";
import * as validator from "validator";

interface ComponentProps {
	/**
	 * Number of textarea rows (height).
	 */
	rows?: number;
	/**
	 * Number of textarea columns (width).
	 */
	cols?: number;
}

type Props =
	ComponentProps
	& EditableProps
	& DisableableProps
	& FocusableProps
	& PressableProps
	& FormGroupProps<string>
	& PlaceholderProps

export default class TextAreaFormGroup extends React.Component<Props, {}> {
	/**
	 * Hot keys map.
	 */
	hotKeysMap = {
		onEnter: 'ctrl+enter'
	};
	/**
	 * Hot keys handlers
	 */
	hotKeysHandlers: any;

	constructor(props: Props) {
		super(props);
		this.hotKeysHandlers = {
			onEnter: props.onEnter ? props.onEnter : () => {}
		}
	}

	componentWillReceiveProps(newProps: Props) {
		if (this.props.onEnter != newProps.onEnter) {
			this.hotKeysHandlers = {
				onEnter: newProps.onEnter ? newProps.onEnter : () => {}
			}
		}
	}

	render() {
		return (
			<HotKeys keyMap={this.hotKeysMap} handlers={this.hotKeysHandlers}>
				<FormGroup label={this.props.label} error={this.props.field.firstError().getOrElse("")}>
					<TextArea onChange={this.onChange}
							  rows={this.props.rows}
							  cols={this.props.cols}
							  value={this.props.field.value.getOrElse("")}
							  disabled={this.props.disabled}
							  focus={this.props.form && this.props.form.hasFocus(this.props.field)}
							  onFocus={() => {
								  this.props.onFocus && this.props.onFocus();
								  this.props.onFocusChange && this.props.onFocusChange(this.props.field);
							  }}
							  hasBorder={true}
							  placeholder={this.props.placeholder}
							  readonly={this.props.readonly}/>
				</FormGroup>
			</HotKeys>
		);
	}

	onChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
		const value = event.target.value;
		this.props.onChange(this.props.field.updateValue(validator.isEmpty(value) ? none : option(value)));
	};
}